module.exports = __webpack_public_path__ + "static/media/layer-group-solid.53de715c.png";